/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionExtraBarIcon = {
    customIcon: function () {
        return Prefab.instantiate(bundles.questsgroupicon.jsons[`merge2mission_extrabar_icon_view_${Merge2MissionHelper.getCurrentPeriod()}_prefab_json`]);
    },
    extraBarWeight: 100002
};
